module.exports = __webpack_public_path__ + "img/pe06.5dcb872c.jpg";